export default {
  AddWelcomeAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addWelcome", payload)
      resolve()
    })
  }
}
